<template>
	<div class="activity-about">
		<!-- 活动介绍 -->
		<div class="activity-about__content" @click="clickRichText">
			<div class="activity-about__rich-text" v-html="detail.introduction"></div>
		</div>

		<!-- 未登录：登录引导 -->
		<div class="activity-about__login-card" v-if="!detail.isDefault && !loginState">
			<div class="activity-about__login-card-title">登录参与更多会议活动，观看更多医学视频</div>
			<van-button type="primary" size="small" round @click="clickLogin">立即登录</van-button>
		</div>

		<!-- 底部操作栏（全局组件 base-footer 承载，默认展示模式不渲染） -->
		<base-footer v-if="!detail.isDefault" background-color="#ffffff">
			<!-- 未登录 -->
			<div class="footer-box" v-if="!loginState">
				<van-button type="primary" block disabled>立即报名</van-button>
				<div class="footer-box__explain">当前登录账号：{{ loginInfo.showMobile || '--' }}</div>
			</div>
			<!-- 医生已报名 -->
			<div class="footer-box" v-else-if="detail.auditStatus == 2">
				<!-- <div class="footer-box__btn-bar">
					<div class="footer-box__btn-main" v-if="detail.activityDoctorDTO && detail.activityDoctorDTO.showBankUpdate">
						<van-button block @click="clickUpdateBankInfo">银行卡</van-button>
					</div>
					<div class="footer-box__btn-main" v-if="detail.type === 8 || (detail.activityDoctorDTO && detail.activityDoctorDTO.signUrl && detail.type === 1)">
						<van-button block @click="clickAgreen">协议</van-button>
					</div>
					<div class="footer-box__btn-main">
						<van-button type="primary" block @click="clickShowActivityProgress">查看进度</van-button>
					</div>
				</div> -->
				<van-button type="primary" block disabled>审核通过</van-button>
				<div class="footer-box__explain">当前登录账号：{{ loginInfo.showMobile || '--' }}</div>
			</div>
			<!-- 未报名 / 审核中 / 审核拒绝 -->
			<div class="footer-box" v-else>
				<div class="footer-agreement" v-if="showAgreement">
					<van-checkbox :value="isAgree" @click="clickToggleAgree"></van-checkbox>
					<div class="footer-agreement__item">
						<span class="footer-agreement__text" @click="clickToggleAgree">我已阅读并同意</span>
						<span class="footer-agreement__text footer-agreement__text--primary" v-if="detail.lhjyAgreementUrl" @click.stop="clickLHAgree">《灵活就业合作伙伴协议》</span>
						<span class="footer-agreement__text footer-agreement__text--primary" v-if="detail.zyzyzAgreementUrl" @click.stop="clickZYAgree">《自由职业者服务协议》</span>
						<span class="footer-agreement__text footer-agreement__text--primary" v-for="item in detail.activityAgreementList || []" :key="item.agreementUrl" @click.stop="clickListAgree(item)">《{{ item.agreementName }}》</span>
					</div>
				</div>
				<!-- 未报名状态 -->
				<van-button v-if="detail.auditStatus === null && detail.isShowZone == 1" type="primary" block @click="clickShowProjectInfo">项目组报名</van-button>
				<van-button v-else-if="detail.auditStatus === null" type="primary" block @click="notBindWhiteHandle">立即报名</van-button>
				<!-- 其它状态（审核中 / 审核拒绝） -->
				<template v-else>
					<van-button v-if="loading.submit" type="primary" block loading>立即报名</van-button>
					<van-button v-else type="primary" block @click="clickSignUp">{{ submitBtnText }}</van-button>
				</template>
				<div class="footer-box__explain">当前登录账号：{{ loginInfo.showMobile || '--' }}</div>
			</div>
		</base-footer>

		<!-- 项目码弹窗 -->
		<van-popup v-model="projectCodeVisible" round position="bottom">
			<div class="project-code-popup">
				<div class="project-code-popup__title">请输入项目码</div>
				<van-field v-model="projectCodeValue" placeholder="请输入项目码" />
				<div class="project-code-popup__btns">
					<van-button block @click="projectCodeVisible = false">取消</van-button>
					<van-button type="primary" block @click="confirmProjectCode">确定</van-button>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
import { ImagePreview, Dialog } from 'vant'

export default {
	name: 'ActivitySignAbout',
	data: () => ({
		options: {},
		loginInfo: {},
		isAgree: false,
		loading: {
			load: false,
			submit: false,
		},
		loginParams: {},
		detail: {},
		// 项目码
		projectCodeVisible: false,
		projectCodeValue: '',
		projectCode: '',
	}),
	computed: {
		user() {
			return this.$store.getters['user/getLoginInfo']
		},
		// 当前登录医生ID
		doctorId() {
			return this.user.userId || this.user.id || ''
		},
		loginState() {
			return !!this.doctorId
		},
		// 是否存在需要勾选的协议
		showAgreement() {
			const { lhjyAgreementUrl, zyzyzAgreementUrl, activityAgreementList } = this.detail
			return !!lhjyAgreementUrl || !!zyzyzAgreementUrl || (activityAgreementList && activityAgreementList.length)
		},
		submitBtnText() {
			if (this.detail.auditStatus == 1) return '审核中'
			if (this.detail.auditStatus == 3) return '审核拒绝'
			return '立即报名'
		},
	},
	created() {
		// 扫码参数：scene=activityId-projectId
		const query = this.$route.query
		const ids = (query.scene || query.id || '').toString().split('-')
		// 默认活动详情展示模式（数据由外部传入，不请求接口）
		if (query.isDefault) {
			this.detail = { isDefault: true }
			return
		}
		this.options = {
			id: ids[0],
			projectId: (query.scene || query.id || '').toString(),
			strProjectId: ids[1],
		}
		if (query.scene) this.options.scene = query.scene
		this.loginParams = {
			type: 'qrcodeActivity',
			activityId: ids[0],
			projectId: ids[1],
			sourceUrl: '/activity/sign/about',
			faceRecognition: 0,
			scene: this.$route.query.scene || ''
		}
		if (this.loginState) this.getUserInfo()
		this.getDetail(() => {
			// 人脸识别完成回跳后直接报名
			if (query.needReport && this.detail.activityDoctorDTO) {
				this.reportActivity()
			}
		})
	},
	methods: {
		clickToggleAgree() {
			this.isAgree = !this.isAgree
		},
		// 获取当前登录医生信息
		getUserInfo() {
			if (!this.doctorId) return Promise.resolve({})
			return this.$api.user.getUserInfo({ id: this.doctorId }).then((res) => {
				if (!res.code && res.data) {
					const loginInfo = res.data
					loginInfo.showMobile = (loginInfo.phone || '').slice(0, 3) + '****' + (loginInfo.phone || '').slice(7)
					this.loginInfo = loginInfo
				}
				return this.loginInfo
			})
		},
		// 获取活动详情
		getDetail(cb = null) {
			this.loading.load = true
			const params = { id: this.options.id }
			if (this.options.strProjectId) params.projectId = this.options.strProjectId
			if (this.doctorId) params.doctorId = this.doctorId
			this.$api.activity
				.activityDetail(params)
				.then((res) => {
					this.loading.load = false
					if (!res.code && res.data) {
						// 富文本图片自适应宽度
						res.data.introduction = this.formatIntroduction(res.data.introduction)
						this.detail = res.data
						this.loginParams.faceRecognition = res.data.faceRecognition
						res.data.name && (document.title = res.data.name)
						// 项目互斥弹窗
						res.data.excludeFlag && this.showExcludeDialog()
						cb && cb()
					}
				})
				.catch(() => {
					this.loading.load = false
				})
		},
		// 富文本图片最大宽度 100%
		formatIntroduction(val = '') {
			return (val || '').replace(/<img/g, '<img style="max-width:100%;object-fit:contain;"')
		},
		// 项目互斥提示
		showExcludeDialog() {
			Dialog.alert({
				title: '温馨提示',
				message: '因活动要求，无法参与',
				confirmButtonText: '关闭',
			})
		},
		// 点击富文本预览图片
		clickRichText() {
			const imgArr = (this.detail.introduction || '')
				.split('src="')
				.filter((item) => item.startsWith('http'))
				.map((item) => item.split('"')[0])
			if (imgArr.length) {
				ImagePreview(imgArr)
			}
		},
		// 点击项目组报名
		clickShowProjectInfo() {
			this.$toast(this.detail.showZoneTxt)
		},
		// 未绑定白名单处理
		notBindWhiteHandle() {
			if (this.detail.enterType == 3) {
				this.$toast('您好, 本项目活动报名名额已满, 请关注后续活动')
			} else {
				this.clickSignUp()
			}
		},
		// 去登录
		clickLogin() {
			this.$router.push({
				path: '/activity/sign/login',
				query: this.loginParams,
			})
		},
		// 点击去报名
		clickSignUp() {
			if (this.showAgreement && !this.isAgree) {
				return this.$toast('请先查看并勾选协议')
			}
			this.$api.activity
				.checkDoctorActivityProject({
					projectId: this.options.id,
					doctorId: this.doctorId,
				})
				.then((res) => {
					if (!res.code) {
						this.getDetail(this.clickSignUpCallback)
					}
				})
		},
		clickSignUpCallback() {
			// 活动审核中和审核失败，直接前往审核结果页
			if (this.detail.auditStatus == 1 || this.detail.auditStatus == 3) {
				this.$router.push(`/activity/sign/audit-result?activityId=${this.options.id}`)
				return
			}
			this.loading.submit = true
			this.getUserInfo().then(() => {
				const userNameAndCard = {
					name: this.loginInfo.name,
					idCard: this.loginInfo.idcard,
				}
				this.loading.submit = false
				if (
					this.loginInfo.idcardStatus == 1 &&
					this.loginInfo.authStatus == 3 &&
					this.detail.cooperationType == 1
				) {
					// 已完成实名且认证通过的合作活动：人脸识别后直接报名
					this.initFace({ ...userNameAndCard, need: this.loginParams.faceRecognition }, () => {
						this.reportActivity()
					})
				} else {
					// 校验登录状态和实名状态
					if (!this.checkUserState()) return
					this.initFace(
						{ need: this.loginParams.faceRecognition, ...userNameAndCard },
						() => {
							this.$router.push(`/activity/sign/audit?activityId=${this.options.id}`)
						},
						`/activity/sign/audit?activityId=${this.options.id}`
					)
				}
			})
		},
		// 去报名
		reportActivity() {
			this.loading.submit = true
			return this.$api.activity
				.reportActivity({
					id: this.detail.activityDoctorDTO.id,
					activityId: this.options.id,
					doctorId: this.doctorId,
					reportParamBody: {
						activityIdList: [this.options.id],
						doctorId: this.doctorId,
						platform: this.detail.platform,
					},
				})
				.then((res) => {
					this.loading.submit = false
					if (!res.code) {
						this.$router.push(`/activity/sign/audit-result?activityId=${this.options.id}`)
					}
				})
				.catch(() => {
					this.loading.submit = false
				})
		},
		// 校验登录状态和实名状态
		checkUserState() {
			if (!this.loginState) {
				this.clickLogin()
				return false
			}
			if (this.loginInfo.idcardStatus == 0) {
				// 未实名：前往实名认证页
				this.$router.push({
					path: '/activity/sign/real-name',
					query: { jsonOptions: JSON.stringify(this.loginParams) },
				})
				return false
			}
			return true
		},
		// 人脸识别（需要时才发起，识别完成后跳转 redirectPath 或回跳本页报名）
		initFace(data, cb, redirectPath = '') {
			if (!data.need) {
				cb && cb()
				return
			}
			const base = window.location.origin + window.location.pathname
			// 未配置回跳地址时，回跳到本页并携带 needReport=1 完成报名
			const redirectUrl = redirectPath
				? base + '#' + redirectPath
				: base + '#' + this.$route.fullPath + (Object.keys(this.$route.query).length ? '&' : '?') + 'needReport=1'
			const formData = {
				name: data.name,
				idNumber: data.idCard,
				sigUrl: encodeURIComponent(redirectUrl),
				callbackUrl: encodeURIComponent(redirectUrl),
			}
			this.$api.base
				.faceRecognitionV2(formData)
				.then((res) => {
					// 用户已经人脸识别过
					if (res.data.code == 20004) {
						cb && cb()
					} else {
						const faceUrl = res.data.faceUrl || ''
						window.location.href = faceUrl
					}
				})
				.catch(() => {
					this.$toast('人脸识别调用失败，请稍后重试')
				})
		},
		// 点击查看进度
		clickShowActivityProgress() {
			if (!this.loginState) return
			if (this.options.scene) {
				this.showActivityProgress()
				return
			}
			// 校验项目码
			this.$api.activity.getIsProjectCode(this.detail.id).then((res) => {
				if (!res.code) {
					if (!res.data) {
						this.showActivityProgress()
					} else {
						this.projectCode = res.data
						this.projectCodeValue = ''
						this.projectCodeVisible = true
					}
				}
			})
		},
		// 确认项目码
		confirmProjectCode() {
			if (!this.projectCodeValue) return this.$toast('请输入项目码')
			if (this.projectCodeValue !== this.projectCode) return this.$toast('项目码错误，请联系管理员')
			this.projectCodeVisible = false
			this.showActivityProgress()
		},
		// 查看活动进度
		showActivityProgress() {
			if (!this.loginState) return
			if (!this.detail.taskJumpUrl) {
				this.$toast('当前活动暂未配置活动进度链接')
				return
			}
			this.$api.activity
				.generateDmSign({
					activityId: this.detail.id,
					doctorId: this.doctorId,
				})
				.then((res) => {
					if (!res.code) {
						const token = this.$store.getters['user/getToken']
						const webviewUrl = `${this.detail.taskJumpUrl}?sign=${res.data}&timestamp=${new Date().getTime()}&type=h5&doctorId=${this.doctorId}&activityId=${this.detail.id}&token=${token}&appid=${this.$store.getters['user/getAppid']}&activityType=${this.detail.type}&commentActivityId=${this.detail.commentActivityId}`
						// H5 环境直接打开活动进度（弹窗被拦截时改为当前页跳转）
						const win = window.open(webviewUrl)
						if (!win) window.location.href = webviewUrl
					}
				})
		},
		// 点击更新银行卡信息
		clickUpdateBankInfo() {
			this.$router.push(`/activity/update-bank-info?activityId=${this.detail.id}`)
		},
		// 跳转协议
		clickAgreen() {
			const token = this.$store.getters['user/getToken']
			if (this.detail.type == 1) {
				// 类型1：预览签名图片
				this.$router.push(`/preview-img?url=${encodeURIComponent(this.detail.activityDoctorDTO.signUrl)}`)
			} else {
				// 其它类型：进入协议签署流程
				this.$router.push(`/meeting/agree/login?token=${token}&activityId=${this.options.id}&doctorId=${this.doctorId}`)
			}
		},
		// 预览协议
		clickLHAgree() {
			this.previewAgreement(this.detail.lhjyAgreementUrl)
		},
		clickZYAgree() {
			this.previewAgreement(this.detail.zyzyzAgreementUrl)
		},
		clickListAgree(item) {
			this.previewAgreement(item.agreementUrl)
		},
		previewAgreement(url) {
			if (!url) return
			ImagePreview([url])
		},
	},
}
</script>

<style lang="less" scoped>
.activity-about {
	min-height: 100vh;
	background-color: #fff;
	box-sizing: border-box;

	&__content {
		// padding: 16px;
		// 底部留白，避免被固定底部栏遮挡
		word-break: break-all;
	}

	&__rich-text {
		font-family: PingFang SC;
		font-size: 14px;
		line-height: 1.6;
		color: #1f2329;

		::v-deep img {
			max-width: 100%;
			vertical-align: middle;
			object-fit: contain;
		}
	}

	&__login-card {
		position: fixed;
		left: 12px;
		right: 12px;
		bottom: 124px;
		z-index: 99;
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 14px 16px;
		background-color: var(--color-primary-light);
		border-radius: 10px;

		&-title {
			flex: 1;
			margin-right: 12px;
			font-family: PingFang SC;
			font-size: 13px;
			font-weight: normal;
			line-height: 20px;
			color: #1f2329;
		}

		.van-button {
			min-width: 88px;
			height: 34px;
		}
	}
}

.footer-box {
	width: 100%;

	&__btn-bar {
		display: flex;
		align-items: center;
	}

	&__btn-main {
		flex: 1;

		+ .footer-box__btn-main {
			padding-left: 13px;
		}
	}

	&__explain {
		padding-top: 10px;
		text-align: center;
		font-family: PingFang SC;
		font-size: 12px;
		color: #888;
	}
}

.footer-agreement {
	display: flex;
	margin: -10px 0 12px;
	font-size: 12px;

	.van-checkbox {
		margin-right: 6px;
		flex-shrink: 0;
	}

	&__item {
		flex: 1;
		white-space: normal;
		word-break: break-all;
		line-height: 18px;
	}

	&__text {
		color: #646a73;

		&--primary {
			color: var(--color-primary);
			font-weight: bold;
		}
	}
}

.project-code-popup {
	padding: 20px 16px;
	padding-bottom: calc(20px + constant(safe-area-inset-bottom));
	padding-bottom: calc(20px + env(safe-area-inset-bottom));

	&__title {
		margin-bottom: 12px;
		font-family: PingFang SC;
		font-size: 16px;
		font-weight: 500;
		text-align: center;
		color: #1f2329;
	}

	&__btns {
		display: flex;
		margin-top: 16px;

		.van-button {
			flex: 1;

			+ .van-button {
				margin-left: 12px;
			}
		}
	}
}
</style>
